import { useCallback } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { ArrowLeftOutlinedIcon } from '~/components/icons'

const FormHeader: React.FC = () => {
  const { t } = useTranslation()
  const router = useRouter()

  const handleBack = useCallback(() => {
    router.push('/staking')
  }, [router])

  return (
    <StyledFormHeader>
      <StyledBackButton onClick={handleBack}>
        <ArrowLeftOutlinedIcon />
      </StyledBackButton>
      <StyledPageTitle>{t('lido_page_title')}</StyledPageTitle>
    </StyledFormHeader>
  )
}

const StyledFormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 -20px 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
`

const StyledBackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  margin-left: 10px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`

const StyledPageTitle = styled.h1`
  flex: 1;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 140%;
  color: ${({ theme }) => theme.colors.textTitle};
  margin: 0;
`

export default FormHeader
